import axios from 'axios'
import React, { useEffect, useState } from 'react'
import HealthIndicator from './HealthIndicator'
import SERVERS from './config.js'

import './styles.css'
import SystemLogsModal from './SystemLogsModal'

// const API_URL = 'http://localhost:2000';
const API_URL = process.env.NODE_ENV === 'production' ? 'https://donitor.m-fair.io' : 'http://localhost:2000';

const App = () => {
  const [unsortedData, setUnsortedData] = useState({});
  const [serverState, setServerState] = useState({});
  const [currentVersions, setCurrentVersions] = useState({})
  const [loading, setLoading] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(undefined);
  const [loggedIn, setLoggedIn] = useState(false);
  const [passphrase, setPassphrase] = useState('');

  useEffect(() => {
    const sortedKeys = Object.keys(unsortedData).sort();
    const newSortedData = {};

    sortedKeys.forEach(key => {
      newSortedData[key] = unsortedData[key];
    });

    setServerState(newSortedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(unsortedData)]);

  const setOfflineIcon = (isOffline, url) => {
    url && console.log(isOffline, url)
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    if (isOffline) {
      setTimeout(() => {
        link.href = 'down.ico';
      }, 1000);
    }
    else if (!isOffline) link.href = 'up.ico';
  }

  useEffect(() => {
    let interval;
    if (loggedIn) {
      const getSyshealth = async (url, c) => {
        console.log('getting syshealth')
        let counter = c || 0;

        axios.get(`${API_URL}/health/?url=${url}&passphrase=${passphrase}`)
          .then(res => {
            res.data?.forEach(container => {
              if (container.name?.includes('lorawan')) return;

              setCurrentVersions(prev => {
                const currentVersion = prev[container.name]
                return {
                  ...prev,
                  [container.name]: currentVersion ? currentVersion < container.version ? container.version : currentVersion : container.version
                }
              })
            })

            setUnsortedData(prev => {
              return {
                ...prev,
                [url]: { health: res.data }
              }
            });

            const containerNr = res.data?.length

            if (containerNr && containerNr < 11) { // if there are less than 10 containers
              setOfflineIcon(true, url);
            } else setOfflineIcon(false, url);
          })
          .catch((e) => { // if there is a timeout
            console.error(e)

            if (counter === 0) {
              console.info('Retrying server ' + c + ' ' + counter + ' ' + url)
              counter++;
              return getSyshealth(url, counter);
            }

            console.log('worked')
            setUnsortedData(prev => {
              return {
                ...prev,
                [url]: { health: [{ name: 'error', state: 'dead' }] }
              }
            });

            setOfflineIcon(true, url);
          })
      }

      SERVERS.map(server => getSyshealth(server));

      interval = setInterval(() => {  // repeat every minute
        SERVERS.map(server => getSyshealth(server));
      }, 60000);
    }
    return () => {
      clearInterval(interval)
    };
  }, [loggedIn, passphrase])

  useEffect(() => {
    // set initial icon to question mark
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = 'favicon.ico';

    if (passphrase && passphrase.length > 20) {
      axios.get(`${API_URL}/login?passphrase=${passphrase}`)
        .then(res => {
          if (res) setLoggedIn(true)
        })
    }
  }, [passphrase])

  if (!loggedIn) {
    return <input
      className='login-input'
      type="password"
      id='password'
      placeholder='Passphrase'
      autoComplete='on'
      onChange={(e) => setPassphrase(e.target.value)}
    />
  }

  return <div className={loading ? 'otherVersion' : ''}>

    <div key='newestVersions' className='row w-100 my-2'>
      <div className={`col w-20`} />
      {Object.keys(currentVersions).map(container => {
        return <div key={`version-${currentVersions[container]}-${container}`} className='col bordered otherVersion cursor-default'>
          {currentVersions[container]?.replace(/v/, '')}
        </div>
      })}
    </div>

    {Object.keys(serverState).map(server => {
      return <div key={server} className='row w-100 my-2'>
        <a
          className={`col w-20 server-url ${serverState[server].health.length !== 11 && 'danger bordered'}`}
          target='_blank'
          href={server}
          rel="noreferrer"
        >
          {server.slice(8).replace(/.m-fair-connect.de/, '')}
        </a>
        {serverState[server].health.map((containerData, index) => {
          if (containerData.name?.includes('lorawan')) return null;
          return <HealthIndicator
            key={`${server}-${containerData.name}`}
            url={server}
            data={containerData}
            versions={currentVersions}
            setSelectedComponent={setSelectedComponent}
          />
        })}
      </div>
    })}

    {!!selectedComponent && <SystemLogsModal
      show={!!selectedComponent}
      loading={loading}
      setLoading={setLoading}
      passphrase={passphrase}
      handleClose={() => setSelectedComponent(undefined)}
      container={selectedComponent}
      API_URL={API_URL}
    />}
  </div>
}

export default App;
